export const SELECT_REQUIRED_ERROR = 'Select an option';
export const MONTHLY_INCOME_REQUIRED_ERROR =
  'Enter your average monthly income';
export const MONTHLY_PAYMENT_REQUIRED_ERROR =
  'Enter your average amount of monthly payment';
